import angular from 'angular';
import '../button';

import { ComboButtonComponent } from './combo-button.component';

angular
  .module('core.components.combo-button', ['core.components.button'])
  .component('easyshipComboButton', ComboButtonComponent);
